// extracted by mini-css-extract-plugin
export var navbar = "VerticalSidebar-module--navbar--2a891";
export var menuBars = "VerticalSidebar-module--menuBars--3NLtt";
export var navMenu = "VerticalSidebar-module--navMenu--38_tG";
export var navMenuItems = "VerticalSidebar-module--navMenuItems--3yqCt";
export var active = "VerticalSidebar-module--active--7A0gn";
export var link = "VerticalSidebar-module--link--3SFp0";
export var navbarToggle = "VerticalSidebar-module--navbarToggle--2HoeD";
export var color = "VerticalSidebar-module--color--3nr_O";